import { Provider } from '@angular/core';

import { MyProfileService } from '@my-profile/services/my-profile.service';
import { MY_PROFILE_STORE } from '@my-profile/stores/my-profile.store';

export const MY_PROFILE_PROVIDERS: Provider[] = [
  MyProfileService,
  MY_PROFILE_STORE
];
